class TeamCalendarListCardDetailController {

  $onInit() {
    this.readOnly = true;
    this.isMobileApp = true;
    this.isTeamCalendarMobile = true;
    this.vacations = this.periodsInDate.filter(period => period.type === 'vacation');
    this.absences  = this.periodsInDate.filter(period => period.type === 'absence');
  }

  hasPeriods() {
    return this.hasVacations() || this.hasAbsences();
  }

  hasVacations() {
    return this.vacations.length > 0;
  }

  hasAbsences() {
    return this.absences.length > 0;
  }

}

export default TeamCalendarListCardDetailController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamCalendarMobile/teamCalendarList/teamCalendarListCard/teamCalendarListCardDetail/teamCalendarListCardDetail.controller.js